<template>
  <div>
    <el-dialog :title="dataForm.id ? 'Edit Config' : 'Add Config'" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" top="1vh">
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" label-position="top">
        <el-form-item label="Country" prop="country">
          <el-select v-model="dataForm.country" class="wdb100" @change="onCountryChange">
            <el-option v-for="item in nativeCountryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Business Type" prop="businessType">
          <el-select v-model="dataForm.businessType" placeholder="Select country first" class="wdb100">
            <el-option v-for="item in filteredBusinessTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Business Specification (EN)" prop="specification">
          <el-editor :height="400" v-model="dataForm.specification" />
        </el-form-item>
        <el-form-item label="Business Specification (CN)" prop="specificationCn">
          <el-editor :height="400" v-model="dataForm.specificationCn" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: "",
        country: "",
        businessType: "",
        specification: "",
        specificationCn: "",
      },
      dataRule: {
        country: [{ required: true, message: "Please select", trigger: "submit" }],
        businessType: [{ required: true, message: "Please select", trigger: "submit" }],
        specification: [{ required: true, message: "Please enter", trigger: "submit" }],
        specificationCn: [{ required: true, message: "Please enter", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList"]),
    nativeCountryList() {
      return this.countryList.filter(i => i.native);
    },
    filteredBusinessTypes() {
      const country = this.countryList.find(i => i.value === this.dataForm.country);
      return country ? country.supportBusinessTypesList : [];
    },
  },
  methods: {
    onCountryChange() {
      this.dataForm.businessType = "";
    },
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          country: data.country,
          businessType: data.businessType,
          specification: data.specification,
          specificationCn: data.specificationCn,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return this.$http.post(`/admin/stBusinessSpecification/${params.id}/update`, params);
      } else {
        return this.$http.post("/admin/stBusinessSpecification/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
